<template>
    <comments-container :comments="user.comments" @add="addCommento" :modify="!readonly"
        @deleteComment="remove"></comments-container>
</template>

<script lang="ts">
import { Prop } from 'vue-property-decorator';
import * as OM from '@/model';
import { Options, Vue } from 'vue-class-component';
import * as VM from '@/viewmodel';
import EventBus from '@/services/EventBus';
import { BaseUserClient } from '@/services/Services';
import { BaseUserServices } from '@/services/BaseUserServices';

@Options({})
export default class commenti extends Vue {

    @Prop() user: OM.Lead;
    @Prop() readonly: boolean;

    addCommento(vm: VM.AddCommentVm){
        vm.entityIdentifier = this.user.identifier;
        BaseUserServices.addCommento(vm)
        .then(x => {
            this.user.comments.unshift(x);
            EventBus.$emit('newcomment');
        })
    }
    
    remove(item: OM.Comment){
        if(!confirm("Confermi la rimozione?")){
            return;
        }
        
        BaseUserClient.removeComment(item.identifier, this.user.identifier)
        .then(x => {
            let index = this.user.comments.findIndex(x => x.identifier == item.identifier);
            this.user.comments.splice(index, 1);
        })
    }

}
</script>
<style scoped>
</style>
